<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="100%" viewBox="0 0 400 265" enable-background="new 0 0 400 265" xml:space="preserve">
<path fill="#0079BE" opacity="1.000000" stroke="none" 
	d="
M1.000000,255.000000 
	C1.000000,174.311905 1.000000,93.623802 1.287967,12.768427 
	C4.695285,9.215133 7.830587,5.843423 10.904046,2.416254 
	C11.152952,2.138702 10.977996,1.481035 11.000000,1.000000 
	C137.354767,1.000000 263.709534,1.000000 390.220520,1.269231 
	C393.430481,4.995707 396.467651,8.468049 399.571136,11.880092 
	C399.806671,12.139027 400.512695,11.970061 401.000000,12.000000 
	C401.000000,92.688103 401.000000,173.376205 400.710602,254.232727 
	C397.298431,257.786987 394.159668,261.158478 391.083069,264.585785 
	C390.836365,264.860596 391.017639,265.519562 391.000000,266.000000 
	C264.645233,266.000000 138.290466,266.000000 11.780117,265.731995 
	C8.572515,262.010284 5.537262,258.541351 2.435519,255.132935 
	C2.196692,254.870499 1.489499,255.034302 1.000000,255.000000 
M107.242592,182.245102 
	C125.317902,208.893143 150.161484,222.752945 182.655670,222.334564 
	C194.649185,222.180130 206.647934,222.178894 218.641541,222.328125 
	C268.954071,222.954132 312.922363,177.174896 308.355255,126.436737 
	C304.414337,82.654991 268.353790,46.381310 224.406647,44.925262 
	C207.599823,44.368423 190.747314,44.463047 173.936325,44.960381 
	C156.468597,45.477142 140.683853,51.502789 126.946892,62.303471 
	C91.261497,90.361099 82.737869,141.547440 107.242592,182.245102 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M10.513435,1.000000 
	C10.977996,1.481035 11.152952,2.138702 10.904046,2.416254 
	C7.830587,5.843423 4.695285,9.215133 1.287967,12.300573 
	C1.000000,8.417958 1.000000,4.835916 1.000000,1.000000 
	C4.006354,1.000000 7.016613,1.000000 10.513435,1.000000 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M401.000000,11.517044 
	C400.512695,11.970061 399.806671,12.139027 399.571136,11.880092 
	C396.467651,8.468049 393.430481,4.995707 390.688354,1.269231 
	C394.257568,1.000000 397.515167,1.000000 401.000000,1.000000 
	C401.000000,4.342758 401.000000,7.688423 401.000000,11.517044 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M1.000000,255.482941 
	C1.489499,255.034302 2.196692,254.870499 2.435519,255.132935 
	C5.537262,258.541351 8.572515,262.010284 11.312263,265.731995 
	C7.742425,266.000000 4.484849,266.000000 1.000000,266.000000 
	C1.000000,262.657257 1.000000,259.311584 1.000000,255.482941 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M391.486572,266.000000 
	C391.017639,265.519562 390.836365,264.860596 391.083069,264.585785 
	C394.159668,261.158478 397.298431,257.786987 400.710602,254.700562 
	C401.000000,258.582031 401.000000,262.164093 401.000000,266.000000 
	C397.993652,266.000000 394.983368,266.000000 391.486572,266.000000 
z"/>
<path fill="#FCFDFE" opacity="1.000000" stroke="none" 
	d="
M107.074387,181.925415 
	C82.737869,141.547440 91.261497,90.361099 126.946892,62.303471 
	C140.683853,51.502789 156.468597,45.477142 173.936325,44.960381 
	C190.747314,44.463047 207.599823,44.368423 224.406647,44.925262 
	C268.353790,46.381310 304.414337,82.654991 308.355255,126.436737 
	C312.922363,177.174896 268.954071,222.954132 218.641541,222.328125 
	C206.647934,222.178894 194.649185,222.180130 182.655670,222.334564 
	C150.161484,222.752945 125.317902,208.893143 107.074387,181.925415 
M101.629616,134.485123 
	C101.746063,148.573257 105.248367,161.759659 111.965744,174.146805 
	C132.990540,212.917419 180.807846,226.247086 218.589630,203.821960 
	C254.311874,182.619232 267.865601,135.458923 249.267288,97.078720 
	C232.395325,62.261044 195.916550,45.283112 158.945129,55.041035 
	C125.665131,63.824673 101.521057,96.856010 101.629616,134.485123 
z"/>
<path fill="#027ABE" opacity="1.000000" stroke="none" 
	d="
M101.613068,133.992188 
	C101.521057,96.856010 125.665131,63.824673 158.945129,55.041035 
	C195.916550,45.283112 232.395325,62.261044 249.267288,97.078720 
	C267.865601,135.458923 254.311874,182.619232 218.589630,203.821960 
	C180.807846,226.247086 132.990540,212.917419 111.965744,174.146805 
	C105.248367,161.759659 101.746063,148.573257 101.613068,133.992188 
M224.565063,154.962555 
	C239.185486,121.158966 216.385498,90.830589 197.709961,86.076340 
	C197.709961,117.621231 197.709961,149.084106 197.709961,181.194168 
	C210.073761,175.773727 218.711823,167.356613 224.565063,154.962555 
M159.537689,180.173172 
	C163.925171,181.867172 161.903488,178.041901 161.908249,176.976746 
	C162.039261,147.676239 162.016510,118.375008 161.997925,89.073914 
	C161.997253,88.026840 161.778839,86.979889 161.590683,85.295158 
	C142.398361,94.437424 132.360901,109.196167 130.350586,129.479843 
	C128.329208,149.875153 139.717392,169.802612 159.537689,180.173172 
z"/>
<path fill="#F9FCFD" opacity="1.000000" stroke="none" 
	d="
M224.389709,155.299713 
	C218.711823,167.356613 210.073761,175.773727 197.709961,181.194168 
	C197.709961,149.084106 197.709961,117.621231 197.709961,86.076340 
	C216.385498,90.830589 239.185486,121.158966 224.389709,155.299713 
z"/>
<path fill="#FDFEFE" opacity="1.000000" stroke="none" 
	d="
M159.177338,180.028290 
	C139.717392,169.802612 128.329208,149.875153 130.350586,129.479843 
	C132.360901,109.196167 142.398361,94.437424 161.590683,85.295158 
	C161.778839,86.979889 161.997253,88.026840 161.997925,89.073914 
	C162.016510,118.375008 162.039261,147.676239 161.908249,176.976746 
	C161.903488,178.041901 163.925171,181.867172 159.177338,180.028290 
z"/>
</svg>